export const hotComics = [
  {
    id: 1,
    title: "我的野蛮王妃",
    author: "朴熙珍",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%20art%2C%20beautiful%20female%20character%20with%20long%20dark%20hair%20in%20elegant%20dress%2C%20soft%20warm%20lighting%2C%20clean%20simple%20background%20in%20pastel%20peach%20tone%2C%20romantic%20atmosphere%2C%20high%20quality%20digital%20illustration%2C%20centered%20composition%2C%20minimalist%20design&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    category: "恋爱",
    rating: 9.6,
    chapters: 128,
    status: "连载中",
    updateTime: "2026-07-02",
    description: "普通女高中生意外进入王室，与冷酷王子展开一段跌宕起伏的浪漫故事。命运的齿轮开始转动，她的出现彻底改变了王室的规则。"
  },
  {
    id: 2,
    title: "剑道至尊",
    author: "金泰亨",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20martial%20arts%20comic%20cover%20art%2C%20male%20swordsman%20character%20holding%20glowing%20sword%2C%20dynamic%20pose%20with%20flowing%20cape%2C%20dramatic%20warm%20orange%20and%20gold%20lighting%2C%20clean%20simple%20background%20in%20cream%20tone%2C%20epic%20fantasy%20atmosphere%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    category: "热血",
    rating: 9.8,
    chapters: 256,
    status: "连载中",
    updateTime: "2026-07-03",
    description: "少年剑客在乱世中崛起，凭借绝世剑法横扫天下。一剑在手，天下我有，这便是他的武道之路。"
  },
  {
    id: 3,
    title: "都市灵异录",
    author: "李智恩",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20mystery%20comic%20cover%20art%2C%20mysterious%20female%20character%20with%20glowing%20eyes%20surrounded%20by%20ethereal%20spirits%2C%20dark%20moody%20atmosphere%20with%20subtle%20warm%20amber%20accents%2C%20clean%20simple%20background%20in%20dark%20cream%20tone%2C%20high%20quality%20digital%20illustration%2C%20centered%20composition&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    category: "悬疑",
    rating: 9.5,
    chapters: 89,
    status: "已完结",
    updateTime: "2026-06-28",
    description: "现代都市中隐藏着不为人知的灵异事件，一位拥有特殊能力的少女成为连接两个世界的桥梁。"
  },
  {
    id: 4,
    title: "重生之商业帝国",
    author: "朴志训",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20business%20drama%20comic%20cover%20art%2C%20confident%20male%20character%20in%20modern%20suit%20standing%20in%20front%20of%20city%20skyline%2C%20warm%20golden%20hour%20lighting%2C%20clean%20simple%20background%20in%20soft%20beige%20tone%2C%20professional%20atmosphere%2C%20high%20quality%20digital%20illustration%2C%20centered%20composition&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    category: "都市",
    rating: 9.7,
    chapters: 192,
    status: "连载中",
    updateTime: "2026-07-01",
    description: "商业天才重生回到二十年前，凭借前世记忆打造属于自己的商业帝国。逆风翻盘，重塑命运！"
  },
  {
    id: 5,
    title: "魔女的条件",
    author: "崔雪莉",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20comic%20cover%20art%2C%20beautiful%20witch%20female%20character%20with%20magical%20powers%20and%20flowing%20long%20silver%20hair%2C%20surrounded%20by%20sparkling%20magic%20particles%2C%20warm%20peach%20and%20pink%20toned%20lighting%2C%20clean%20simple%20background%20in%20soft%20cream%20tone%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    category: "奇幻",
    rating: 9.4,
    chapters: 156,
    status: "连载中",
    updateTime: "2026-07-02",
    description: "一位普通女孩意外觉醒了魔女的力量，在魔法与现实的交织中寻找属于自己的命运。"
  },
  {
    id: 6,
    title: "校园风云榜",
    author: "郑宇盛",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20comedy%20comic%20cover%20art%2C%20energetic%20male%20student%20character%20with%20mischievous%20smile%20in%20school%20uniform%2C%20bright%20and%20cheerful%20atmosphere%2C%20warm%20sunlight%20color%20palette%2C%20clean%20simple%20background%20in%20light%20beige%20tone%2C%20high%20quality%20digital%20illustration%2C%20dynamic%20composition&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    category: "校园",
    rating: 9.3,
    chapters: 210,
    status: "已完结",
    updateTime: "2026-05-15",
    description: "转学生来到新学校，凭借独特魅力迅速成为校园风云人物。青春、友情、热血，一切尽在校园！"
  }
];

export const latestUpdates = [
  {
    id: 7,
    title: "暗夜追踪者",
    author: "金智秀",
    chapter: "第89话",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20noir%20comic%20cover%20art%2C%20detective%20character%20in%20trench%20coat%20standing%20in%20rainy%20alley%2C%20dark%20atmospheric%20lighting%20with%20warm%20streetlamp%20glow%2C%20clean%20simple%20background%20in%20dark%20beige%20tone%2C%20high%20quality%20digital%20illustration%2C%20centered%20composition&width=200&height=280&seq=comic-cover-07&orientation=portrait",
    category: "悬疑",
    updateTime: "2小时前",
  },
  {
    id: 8,
    title: "美食猎人",
    author: "李多海",
    chapter: "第56话",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20food%20cooking%20comic%20cover%20art%2C%20cheerful%20chef%20character%20holding%20delicious%20dish%2C%20warm%20and%20inviting%20kitchen%20atmosphere%2C%20soft%20golden%20lighting%2C%20clean%20simple%20background%20in%20cream%20tone%2C%20high%20quality%20digital%20illustration%2C%20appetizing%20composition&width=200&height=280&seq=comic-cover-08&orientation=portrait",
    category: "美食",
    updateTime: "5小时前",
  },
  {
    id: 9,
    title: "星际逃亡",
    author: "朴宝剑",
    chapter: "第134话",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20space%20comic%20cover%20art%2C%20spaceship%20pilot%20character%20in%20futuristic%20suit%20with%20stars%20in%20background%2C%20deep%20space%20atmosphere%20with%20warm%20nebula%20colors%2C%20clean%20simple%20background%20in%20navy%20cream%20tone%2C%20high%20quality%20digital%20illustration&width=200&height=280&seq=comic-cover-09&orientation=portrait",
    category: "科幻",
    updateTime: "8小时前",
  },
  {
    id: 10,
    title: "王朝秘史",
    author: "韩彩英",
    chapter: "第67话",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20drama%20comic%20cover%20art%2C%20noble%20character%20in%20traditional%20Korean%20hanbok%20costume%2C%20palace%20background%20with%20warm%20amber%20lighting%2C%20elegant%20historical%20atmosphere%2C%20clean%20simple%20background%20in%20beige%20tone%2C%20high%20quality%20digital%20illustration&width=200&height=280&seq=comic-cover-10&orientation=portrait",
    category: "历史",
    updateTime: "12小时前",
  },
  {
    id: 11,
    title: "极限运动王",
    author: "宋仲基",
    chapter: "第43话",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20sports%20action%20comic%20cover%20art%2C%20athletic%20male%20character%20performing%20extreme%20sports%20dynamic%20pose%2C%20energetic%20atmosphere%20with%20warm%20sunlight%2C%20clean%20simple%20background%20in%20light%20cream%20tone%2C%20high%20quality%20digital%20illustration%2C%20action%20composition&width=200&height=280&seq=comic-cover-11&orientation=portrait",
    category: "运动",
    updateTime: "1天前",
  },
  {
    id: 12,
    title: "魔法学院",
    author: "裴秀智",
    chapter: "第201话",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20magic%20academy%20fantasy%20comic%20cover%20art%2C%20young%20magician%20student%20character%20casting%20spell%20with%20magical%20effects%2C%20enchanting%20atmosphere%20with%20warm%20golden%20magic%20glow%2C%20clean%20simple%20background%20in%20cream%20tone%2C%20high%20quality%20digital%20illustration&width=200&height=280&seq=comic-cover-12&orientation=portrait",
    category: "奇幻",
    updateTime: "1天前",
  },
];

export const categories = [
  { name: "恋爱", slug: "romance", icon: "ri-heart-line", count: 1280 },
  { name: "热血", slug: "action", icon: "ri-fire-line", count: 960 },
  { name: "悬疑", slug: "mystery", icon: "ri-search-eye-line", count: 540 },
  { name: "都市", slug: "urban", icon: "ri-building-line", count: 820 },
  { name: "奇幻", slug: "fantasy", icon: "ri-magic-line", count: 1100 },
  { name: "校园", slug: "school", icon: "ri-book-open-line", count: 750 },
  { name: "美食", slug: "food", icon: "ri-restaurant-line", count: 320 },
  { name: "科幻", slug: "scifi", icon: "ri-rocket-line", count: 480 },
  { name: "历史", slug: "history", icon: "ri-ancient-gate-line", count: 390 },
  { name: "运动", slug: "sports", icon: "ri-basketball-line", count: 280 },
];

export const faqData = [
  {
    question: "韩国漫画网是否需要付费？",
    answer: "韩国漫画网上的所有漫画资源均为免费在线观看，无需任何付费。我们致力于为广大漫迷提供完全免费的优质阅读体验，您可以随时随地畅享高清韩漫。"
  },
  {
    question: "如何找到我想看的漫画？",
    answer: "您可以通过网站顶部的搜索功能直接搜索漫画名称，也可以在首页的分类入口按类型浏览。我们还提供热门推荐和最新更新列表，帮助您快速发现优质漫画。"
  },
  {
    question: "网站支持哪些设备阅读？",
    answer: "韩国漫画网完美支持电脑、平板和手机等多种设备。无论您使用什么设备，都能获得流畅清晰的阅读体验。网站采用响应式设计，自动适配不同屏幕尺寸。"
  },
  {
    question: "漫画更新频率如何？",
    answer: "我们的编辑团队每天都会更新大量漫画章节，确保您能第一时间看到最新内容。热门连载漫画通常保持每周至少2-3话的更新速度。"
  },
  {
    question: "遇到加载缓慢或无法显示怎么办？",
    answer: "如遇到加载问题，建议您尝试刷新页面或切换网络环境。我们的服务器采用CDN加速技术，正常情况下加载速度非常快。如问题持续存在，请通过关于我们页面的联系方式与我们沟通。"
  },
];

export const testimonials = [
  {
    name: "林小曼",
    role: "资深漫迷 · 5年阅读龄",
    avatar: "https://readdy.ai/api/search-image?query=Asian%20young%20woman%20portrait%20photography%2C%20natural%20lighting%2C%20soft%20warm%20tone%2C%20simple%20neutral%20gray%20background%2C%20professional%20headshot%20style%2C%20gentle%20smile%2C%20clean%20minimalist%20aesthetic%2C%20high%20quality%20editorial%20portrait&width=300&height=400&seq=testimonial-avatar-01&orientation=portrait",
    content: "韩国漫画网的资源真的太丰富了！以前在别的平台找不到的韩漫这里全都有，而且画质超级清晰，加载速度也快。每天下班回家第一件事就是打开网站追更新，已经成了我的生活习惯！"
  },
  {
    name: "张浩然",
    role: "漫画博主 · 10万粉丝",
    avatar: "https://readdy.ai/api/search-image?query=Asian%20young%20man%20portrait%20photography%2C%20natural%20soft%20lighting%2C%20warm%20neutral%20tone%2C%20simple%20clean%20gray%20background%2C%20professional%20headshot%20style%2C%20confident%20expression%2C%20minimalist%20aesthetic%2C%20high%20quality%20editorial%20portrait&width=300&height=400&seq=testimonial-avatar-02&orientation=portrait",
    content: "作为漫画领域的博主，我经常向粉丝推荐韩国漫画网。这个平台无论是内容质量还是用户体验都堪称一流，分类清晰、搜索精准，是我用过最好的韩漫阅读网站。"
  },
  {
    name: "陈雨萱",
    role: "大学生 · 韩漫爱好者",
    avatar: "https://readdy.ai/api/search-image?query=Asian%20young%20female%20portrait%20photography%2C%20natural%20warm%20lighting%2C%20soft%20neutral%20tone%2C%20simple%20clean%20gray%20background%2C%20professional%20headshot%20style%2C%20bright%20smile%2C%20minimalist%20aesthetic%2C%20high%20quality%20editorial%20portrait&width=300&height=400&seq=testimonial-avatar-03&orientation=portrait",
    content: "室友推荐的这个网站，一试就爱上了！界面设计简洁好看，阅读体验特别舒服。而且更新速度真的很快，每次想看新章节的时候基本都已经更新好了，太贴心了！"
  }
];

export interface ComicDetail {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  rating: number;
  chapters: number;
  status: string;
  updateTime: string;
  description: string;
  longDescription: string;
}

export const allComics: ComicDetail[] = [
  {
    id: 1,
    title: "我的野蛮王妃",
    author: "朴熙珍",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%20art%2C%20beautiful%20female%20character%20with%20long%20dark%20hair%20in%20elegant%20dress%2C%20soft%20warm%20lighting%2C%20clean%20simple%20background%20in%20pastel%20peach%20tone%2C%20romantic%20atmosphere%2C%20high%20quality%20digital%20illustration%2C%20centered%20composition%2C%20minimalist%20design&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    category: "恋爱",
    rating: 9.6,
    chapters: 128,
    status: "连载中",
    updateTime: "2026-07-02",
    description: "普通女高中生意外进入王室，与冷酷王子展开一段跌宕起伏的浪漫故事。",
    longDescription: "普通女高中生意外进入王室，与冷酷王子展开一段跌宕起伏的浪漫故事。命运的齿轮开始转动，她的出现彻底改变了王室的规则。在这个充满阴谋与权术的宫廷中，纯真的爱情能否经受住重重考验？"
  },
  {
    id: 2,
    title: "剑道至尊",
    author: "金泰亨",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20martial%20arts%20comic%20cover%20art%2C%20male%20swordsman%20character%20holding%20glowing%20sword%2C%20dynamic%20pose%20with%20flowing%20cape%2C%20dramatic%20warm%20orange%20and%20gold%20lighting%2C%20clean%20simple%20background%20in%20cream%20tone%2C%20epic%20fantasy%20atmosphere%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    category: "热血",
    rating: 9.8,
    chapters: 256,
    status: "连载中",
    updateTime: "2026-07-03",
    description: "少年剑客在乱世中崛起，凭借绝世剑法横扫天下。",
    longDescription: "少年剑客在乱世中崛起，凭借绝世剑法横扫天下。一剑在手，天下我有，这便是他的武道之路。从默默无闻的乡村少年，到威震四方的剑道至尊，他的传奇故事激励着无数后辈武者砥砺前行。"
  },
  {
    id: 3,
    title: "都市灵异录",
    author: "李智恩",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20mystery%20comic%20cover%20art%2C%20mysterious%20female%20character%20with%20glowing%20eyes%20surrounded%20by%20ethereal%20spirits%2C%20dark%20moody%20atmosphere%20with%20subtle%20warm%20amber%20accents%2C%20clean%20simple%20background%20in%20dark%20cream%20tone%2C%20high%20quality%20digital%20illustration%2C%20centered%20composition&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    category: "悬疑",
    rating: 9.5,
    chapters: 89,
    status: "已完结",
    updateTime: "2026-06-28",
    description: "现代都市中隐藏着不为人知的灵异事件，一位拥有特殊能力的少女成为连接两个世界的桥梁。",
    longDescription: "现代都市中隐藏着不为人知的灵异事件，一位拥有特殊能力的少女成为连接两个世界的桥梁。每一个灵异事件背后，都隐藏着令人心碎的故事。跟随主角的脚步，揭开都市的神秘面纱，探索未知世界的真相。"
  },
  {
    id: 4,
    title: "重生之商业帝国",
    author: "朴志训",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20business%20drama%20comic%20cover%20art%2C%20confident%20male%20character%20in%20modern%20suit%20standing%20in%20front%20of%20city%20skyline%2C%20warm%20golden%20hour%20lighting%2C%20clean%20simple%20background%20in%20soft%20beige%20tone%2C%20professional%20atmosphere%2C%20high%20quality%20digital%20illustration%2C%20centered%20composition&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    category: "都市",
    rating: 9.7,
    chapters: 192,
    status: "连载中",
    updateTime: "2026-07-01",
    description: "商业天才重生回到二十年前，凭借前世记忆打造属于自己的商业帝国。",
    longDescription: "商业天才重生回到二十年前，凭借前世记忆打造属于自己的商业帝国。逆风翻盘，重塑命运！前世的所有遗憾，今世都要一一弥补。从一个小小的创业者到商业帝国的缔造者，这不仅是财富的积累，更是一场关于人性的深刻探索。"
  },
  {
    id: 5,
    title: "魔女的条件",
    author: "崔雪莉",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20comic%20cover%20art%2C%20beautiful%20witch%20female%20character%20with%20magical%20powers%20and%20flowing%20long%20silver%20hair%2C%20surrounded%20by%20sparkling%20magic%20particles%2C%20warm%20peach%20and%20pink%20toned%20lighting%2C%20clean%20simple%20background%20in%20soft%20cream%20tone%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    category: "奇幻",
    rating: 9.4,
    chapters: 156,
    status: "连载中",
    updateTime: "2026-07-02",
    description: "一位普通女孩意外觉醒了魔女的力量，在魔法与现实的交织中寻找属于自己的命运。",
    longDescription: "一位普通女孩意外觉醒了魔女的力量，在魔法与现实的交织中寻找属于自己的命运。她必须在光明与黑暗之间做出选择，而每一个选择都将改变世界的走向。这是一场关于成长、勇气与爱的史诗级奇幻冒险。"
  },
  {
    id: 6,
    title: "校园风云榜",
    author: "郑宇盛",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20comedy%20comic%20cover%20art%2C%20energetic%20male%20student%20character%20with%20mischievous%20smile%20in%20school%20uniform%2C%20bright%20and%20cheerful%20atmosphere%2C%20warm%20sunlight%20color%20palette%2C%20clean%20simple%20background%20in%20light%20beige%20tone%2C%20high%20quality%20digital%20illustration%2C%20dynamic%20composition&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    category: "校园",
    rating: 9.3,
    chapters: 210,
    status: "已完结",
    updateTime: "2026-05-15",
    description: "转学生来到新学校，凭借独特魅力迅速成为校园风云人物。",
    longDescription: "转学生来到新学校，凭借独特魅力迅速成为校园风云人物。青春、友情、热血，一切尽在校园！这里有搞笑日常、感人瞬间，还有那些年我们一起追过的梦想，是最纯粹的青春物语。"
  },
  {
    id: 7,
    title: "暗夜追踪者",
    author: "金智秀",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20noir%20comic%20cover%20art%2C%20detective%20character%20in%20trench%20coat%20standing%20in%20rainy%20alley%2C%20dark%20atmospheric%20lighting%20with%20warm%20streetlamp%20glow%2C%20clean%20simple%20background%20in%20dark%20beige%20tone%2C%20high%20quality%20digital%20illustration%2C%20centered%20composition&width=400&height=560&seq=comic-cover-07&orientation=portrait",
    category: "悬疑",
    rating: 9.2,
    chapters: 89,
    status: "连载中",
    updateTime: "2026-07-01",
    description: "神秘侦探在黑夜中追查连环案件，每一个线索都指向更深的阴谋。",
    longDescription: "神秘侦探在黑夜中追查连环案件，每一个线索都指向更深的阴谋。在繁华都市的阴影之下，一场惊心动魄的猫鼠游戏正在上演。真相往往比想象中更加黑暗，而正义的代价令人心碎。"
  },
  {
    id: 8,
    title: "美食猎人",
    author: "李多海",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20food%20cooking%20comic%20cover%20art%2C%20cheerful%20chef%20character%20holding%20delicious%20dish%2C%20warm%20and%20inviting%20kitchen%20atmosphere%2C%20soft%20golden%20lighting%2C%20clean%20simple%20background%20in%20cream%20tone%2C%20high%20quality%20digital%20illustration%2C%20appetizing%20composition&width=400&height=560&seq=comic-cover-08&orientation=portrait",
    category: "美食",
    rating: 9.1,
    chapters: 56,
    status: "连载中",
    updateTime: "2026-07-02",
    description: "天才厨师踏上寻找传说食材的旅程，用美食治愈人心。",
    longDescription: "天才厨师踏上寻找传说食材的旅程，用美食治愈人心。每一道菜品都承载着一段动人的故事，每一次烹饪都是与食材的灵魂对话。跟着美食猎人的脚步，品味世界各地的珍馐美味，感受食物背后的人情冷暖。"
  },
  {
    id: 9,
    title: "星际逃亡",
    author: "朴宝剑",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20space%20comic%20cover%20art%2C%20spaceship%20pilot%20character%20in%20futuristic%20suit%20with%20stars%20in%20background%2C%20deep%20space%20atmosphere%20with%20warm%20nebula%20colors%2C%20clean%20simple%20background%20in%20navy%20cream%20tone%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-09&orientation=portrait",
    category: "科幻",
    rating: 9.5,
    chapters: 134,
    status: "连载中",
    updateTime: "2026-06-30",
    description: "人类在星际间逃亡求生，一艘艘飞船承载着最后的希望。",
    longDescription: "人类在星际间逃亡求生，一艘艘飞船承载着最后的希望。在浩瀚宇宙中，一群幸存者为了寻找新的家园而踏上危险旅程。面对未知的宇宙威胁和内部的分歧，他们能否找到人类文明的新曙光？"
  },
  {
    id: 10,
    title: "王朝秘史",
    author: "韩彩英",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20drama%20comic%20cover%20art%2C%20noble%20character%20in%20traditional%20Korean%20hanbok%20costume%2C%20palace%20background%20with%20warm%20amber%20lighting%2C%20elegant%20historical%20atmosphere%2C%20clean%20simple%20background%20in%20beige%20tone%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-10&orientation=portrait",
    category: "历史",
    rating: 9.4,
    chapters: 67,
    status: "连载中",
    updateTime: "2026-07-01",
    description: "揭开朝鲜王朝不为人知的宫廷秘辛，权谋与爱情交织的史诗。",
    longDescription: "揭开朝鲜王朝不为人知的宫廷秘辛，权谋与爱情交织的史诗。在权力与欲望的漩涡中，每个人都在为生存而挣扎。宫廷深处的秘密，真相远比史书记载的更加惊心动魄。"
  },
  {
    id: 11,
    title: "极限运动王",
    author: "宋仲基",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20sports%20action%20comic%20cover%20art%2C%20athletic%20male%20character%20performing%20extreme%20sports%20dynamic%20pose%2C%20energetic%20atmosphere%20with%20warm%20sunlight%2C%20clean%20simple%20background%20in%20light%20cream%20tone%2C%20high%20quality%20digital%20illustration%2C%20action%20composition&width=400&height=560&seq=comic-cover-11&orientation=portrait",
    category: "运动",
    rating: 9.0,
    chapters: 43,
    status: "连载中",
    updateTime: "2026-07-02",
    description: "热血青年挑战极限运动，用汗水和勇气征服不可能。",
    longDescription: "热血青年挑战极限运动，用汗水和勇气征服不可能。从街头滑板到高山滑雪，每一次腾空都是对自我的超越。这不仅是一部运动漫画，更是一首献给青春与梦想的激昂赞歌。"
  },
  {
    id: 12,
    title: "魔法学院",
    author: "裴秀智",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20magic%20academy%20fantasy%20comic%20cover%20art%2C%20young%20magician%20student%20character%20casting%20spell%20with%20magical%20effects%2C%20enchanting%20atmosphere%20with%20warm%20golden%20magic%20glow%2C%20clean%20simple%20background%20in%20cream%20tone%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-12&orientation=portrait",
    category: "奇幻",
    rating: 9.3,
    chapters: 201,
    status: "已完结",
    updateTime: "2026-06-15",
    description: "在魔法学院中，平凡少年踏上了成为传奇大法师的征途。",
    longDescription: "在魔法学院中，平凡少年踏上了成为传奇大法师的征途。从不会施展最简单的魔法咒语，到最终掌握足以改变世界的至高奥术，他的成长之路充满了欢笑、泪水与感动。"
  },
  {
    id: 13,
    title: "纯情罗曼史",
    author: "金素妍",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20pure%20romance%20comic%20cover%20art%2C%20young%20couple%20holding%20hands%20in%20cherry%20blossom%20park%2C%20soft%20pink%20and%20peach%20lighting%2C%20romantic%20dreamy%20atmosphere%2C%20clean%20simple%20background%20in%20light%20cream%20tone%2C%20high%20quality%20digital%20illustration%2C%20intimate%20composition&width=400&height=560&seq=comic-cover-13&orientation=portrait",
    category: "恋爱",
    rating: 9.5,
    chapters: 95,
    status: "已完结",
    updateTime: "2026-05-20",
    description: "青梅竹马的两人在成长中逐渐发现对彼此的特殊感情。",
    longDescription: "青梅竹马的两人在成长中逐渐发现对彼此的特殊感情。从童年的玩伴到青春期的悸动，再到成年后的深情告白，他们的故事温暖了无数读者的心灵。这是一部关于时间、成长与真爱的动人篇章。"
  },
  {
    id: 14,
    title: "霸道总裁爱上我",
    author: "刘诗雅",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20comic%20cover%20art%2C%20handsome%20male%20CEO%20in%20sharp%20suit%20and%20beautiful%20female%20employee%2C%20warm%20golden%20office%20lighting%2C%20clean%20simple%20background%20in%20soft%20beige%20tone%2C%20professional%20romantic%20atmosphere%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-14&orientation=portrait",
    category: "恋爱",
    rating: 9.2,
    chapters: 78,
    status: "连载中",
    updateTime: "2026-07-03",
    description: "普通上班族与冷面总裁之间发生的甜蜜又虐心的爱情故事。",
    longDescription: "普通上班族与冷面总裁之间发生的甜蜜又虐心的爱情故事。当理性与感性碰撞，当职场与爱情交织，两个人的生活从此天翻地覆。这是一个关于打破规则、勇敢去爱的都市浪漫物语。"
  },
  {
    id: 15,
    title: "武道宗师",
    author: "郑俊浩",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20comic%20cover%20art%2C%20powerful%20martial%20artist%20character%20in%20fighting%20stance%20with%20energy%20aura%2C%20dramatic%20dynamic%20lighting%20with%20warm%20golden%20tones%2C%20clean%20simple%20background%20in%20cream%20tone%2C%20epic%20action%20atmosphere%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-15&orientation=portrait",
    category: "热血",
    rating: 9.7,
    chapters: 320,
    status: "连载中",
    updateTime: "2026-07-02",
    description: "武道之路上，唯有不断突破自我才能登上巅峰。",
    longDescription: "武道之路上，唯有不断突破自我才能登上巅峰。从卑微的武道馆学徒到万人敬仰的武道宗师，他用了三十年时间走完了常人一生都无法企及的道路。这不仅是一部关于武学的漫画，更是一曲关于坚持与信念的壮丽史诗。"
  },
  {
    id: 16,
    title: "地下城征服者",
    author: "尹智昊",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20dungeon%20adventure%20fantasy%20comic%20cover%20art%2C%20adventurer%20character%20with%20sword%20and%20shield%20facing%20massive%20dungeon%20gate%2C%20dramatic%20lighting%20with%20warm%20torch%20glow%2C%20clean%20simple%20background%20in%20dark%20cream%20tone%2C%20epic%20fantasy%20atmosphere%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-16&orientation=portrait",
    category: "热血",
    rating: 9.6,
    chapters: 188,
    status: "连载中",
    updateTime: "2026-07-01",
    description: "地下城深处藏着无尽的宝藏与危险，勇士们组队挑战极限。",
    longDescription: "地下城深处藏着无尽的宝藏与危险，勇士们组队挑战极限。每一次深入地下城都是一次生死考验，而他们最大的敌人或许不是地下的怪物，而是人性中的贪婪与背叛。一场关于勇气、友情与牺牲的地下城史诗。"
  },
  {
    id: 17,
    title: "时间囚徒",
    author: "徐贤真",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20time%20travel%20thriller%20comic%20cover%20art%2C%20character%20surrounded%20by%20floating%20clock%20faces%20and%20time%20fragments%2C%20surreal%20atmosphere%20with%20warm%20amber%20and%20gold%20tones%2C%20clean%20simple%20background%20in%20soft%20cream%20tone%2C%20mysterious%20aesthetic%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-17&orientation=portrait",
    category: "悬疑",
    rating: 9.4,
    chapters: 62,
    status: "连载中",
    updateTime: "2026-06-29",
    description: "被困在时间循环中的男人，必须找出真相才能打破诅咒。",
    longDescription: "被困在时间循环中的男人，必须找出真相才能打破诅咒。每一天都是同样的开始，但每一天的结局都各不相同。真相隐藏在过去之中，而解开谜题的钥匙，正是他自己早已遗忘的记忆。"
  },
  {
    id: 18,
    title: "都市猎艳高手",
    author: "安宰贤",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20urban%20drama%20comic%20cover%20art%2C%20stylish%20male%20character%20in%20trendy%20casual%20outfit%20walking%20through%20neon-lit%20city%20street%20at%20night%2C%20warm%20colorful%20ambient%20lighting%2C%20clean%20simple%20background%20in%20dark%20cream%20tone%2C%20modern%20urban%20atmosphere%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-18&orientation=portrait",
    category: "都市",
    rating: 9.1,
    chapters: 145,
    status: "已完结",
    updateTime: "2026-04-30",
    description: "都市夜生活里的浪漫邂逅，关于爱情、友情与成长的都市物语。",
    longDescription: "都市夜生活里的浪漫邂逅，关于爱情、友情与成长的都市物语。在霓虹灯闪烁的繁华都市中，一群年轻人的生活轨迹意外交织。每一段感情都是一场冒险，每一次选择都可能改变人生。"
  },
  {
    id: 19,
    title: "元素召唤师",
    author: "权志龙",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20elemental%20magic%20fantasy%20comic%20cover%20art%2C%20young%20mage%20character%20commanding%20fire%20water%20earth%20and%20air%20elements%2C%20surrounded%20by%20elemental%20energy%20swirls%2C%20warm%20magical%20lighting%2C%20clean%20simple%20background%20in%20cream%20tone%2C%20epic%20fantasy%20atmosphere%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-19&orientation=portrait",
    category: "奇幻",
    rating: 9.5,
    chapters: 230,
    status: "连载中",
    updateTime: "2026-07-03",
    description: "掌握四大元素之力的召唤师，为守护世界而战斗。",
    longDescription: "掌握四大元素之力的召唤师，为守护世界而战斗。当古老的封印被打破，黑暗势力卷土重来，只有元素召唤师才能拯救濒临崩溃的世界。火、水、风、土——四大元素的平衡，是和平的唯一希望。"
  },
  {
    id: 20,
    title: "我的同桌是校花",
    author: "孙艺珍",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20high%20school%20romance%20comedy%20comic%20cover%20art%2C%20cute%20female%20student%20character%20sitting%20at%20classroom%20desk%20looking%20back%20with%20gentle%20smile%2C%20bright%20warm%20sunlight%20through%20window%2C%20clean%20simple%20background%20in%20light%20beige%20tone%2C%20youthful%20atmosphere%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-20&orientation=portrait",
    category: "校园",
    rating: 9.3,
    chapters: 165,
    status: "已完结",
    updateTime: "2026-03-28",
    description: "普通男生与校花同桌的校园日常，笑中带泪的青春回忆。",
    longDescription: "普通男生与校花同桌的校园日常，笑中带泪的青春回忆。从最初的互看不顺眼，到逐渐成为彼此最特别的存在。那些年我们一起度过的校园时光，是最珍贵的人生礼物。"
  },
  {
    id: 21,
    title: "星空下的约定",
    author: "金秀贤",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20stargazing%20romance%20comic%20cover%20art%2C%20young%20couple%20lying%20on%20grass%20field%20looking%20up%20at%20starry%20night%20sky%2C%20warm%20romantic%20moonlight%20atmosphere%2C%20clean%20simple%20background%20in%20dark%20navy%20cream%20tone%2C%20dreamy%20aesthetic%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-21&orientation=portrait",
    category: "恋爱",
    rating: 9.4,
    chapters: 72,
    status: "连载中",
    updateTime: "2026-07-02",
    description: "天文社的两人在星空下许下约定，一场跨越时空的爱恋。",
    longDescription: "天文社的两人在星空下许下约定，一场跨越时空的爱恋。每一个星座都见证着他们的故事，每一颗流星都承载着他们的愿望。这是一部关于宇宙、关于梦想、关于永恒之爱的浪漫传奇。"
  },
  {
    id: 22,
    title: "足球少年梦",
    author: "朴智星",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20soccer%20sports%20comic%20cover%20art%2C%20young%20soccer%20player%20character%20in%20dynamic%20running%20pose%20on%20green%20field%2C%20dramatic%20stadium%20lighting%20with%20warm%20golden%20sunset%2C%20clean%20simple%20background%20in%20cream%20tone%2C%20sports%20action%20atmosphere%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-22&orientation=portrait",
    category: "运动",
    rating: 9.2,
    chapters: 98,
    status: "连载中",
    updateTime: "2026-06-28",
    description: "热爱足球的少年追逐职业梦想，汗水与热血铸就传奇。",
    longDescription: "热爱足球的少年追逐职业梦想，汗水与热血铸就传奇。从街头巷尾的野球场到万人瞩目的职业联赛，他用双脚踢出了一个属于自己的精彩人生。这不仅是一部足球漫画，更是一首关于梦想的青春赞歌。"
  },
  {
    id: 23,
    title: "异世界料理屋",
    author: "姜虎东",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cooking%20comic%20cover%20art%2C%20chef%20character%20in%20fantasy%20world%20kitchen%20surrounded%20by%20magical%20ingredients%2C%20warm%20cozy%20atmosphere%20with%20golden%20candlelight%2C%20clean%20simple%20background%20in%20cream%20tone%2C%20appetizing%20fantasy%20aesthetic%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-23&orientation=portrait",
    category: "美食",
    rating: 9.3,
    chapters: 85,
    status: "连载中",
    updateTime: "2026-07-01",
    description: "穿越到异世界的厨师用现代料理征服奇幻世界。",
    longDescription: "穿越到异世界的厨师用现代料理征服奇幻世界。当中华小当家遇上西方奇幻，会碰撞出怎样的火花？用美食连接两个世界，用味道传递温暖与感动，这是一部让读者看完就想冲进厨房的治愈系美食漫画。"
  },
  {
    id: 24,
    title: "王朝之剑",
    author: "李秉宪",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20fantasy%20comic%20cover%20art%2C%20warrior%20character%20in%20traditional%20armor%20holding%20ornate%20sword%2C%20ancient%20palace%20background%20with%20warm%20dramatic%20lighting%2C%20clean%20simple%20background%20in%20beige%20tone%2C%20epic%20historical%20atmosphere%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-24&orientation=portrait",
    category: "历史",
    rating: 9.6,
    chapters: 124,
    status: "已完结",
    updateTime: "2026-02-15",
    description: "动荡年代的忠臣义士，用生命守护王朝最后的荣耀。",
    longDescription: "动荡年代的忠臣义士，用生命守护王朝最后的荣耀。当外敌入侵、内乱迭起，一个忠勇之士挺身而出，以一己之力力挽狂澜。这不仅是一部关于战争与荣耀的史诗，更是对人性与忠诚的深刻思考。"
  },
  {
    id: 25,
    title: "银河舰队",
    author: "赵寅成",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20military%20sci-fi%20comic%20cover%20art%2C%20fleet%20commander%20character%20in%20futuristic%20uniform%20standing%20before%20massive%20spaceship%20bridge%2C%20dramatic%20space%20lighting%20with%20warm%20star%20glow%2C%20clean%20simple%20background%20in%20dark%20navy%20cream%20tone%2C%20epic%20sci-fi%20atmosphere%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-25&orientation=portrait",
    category: "科幻",
    rating: 9.4,
    chapters: 178,
    status: "连载中",
    updateTime: "2026-07-03",
    description: "银河舰队保卫人类疆域，与外星文明展开星际大战。",
    longDescription: "银河舰队保卫人类疆域，与外星文明展开星际大战。在广阔的银河系中，人类舰队面临着前所未有的挑战。科技、战术、勇气——决定胜负的因素远不止于此。这是一部献给每一位仰望星空者的太空歌剧。"
  },
  {
    id: 26,
    title: "武林争霸",
    author: "张赫",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20wuxia%20martial%20arts%20comic%20cover%20art%2C%20martial%20arts%20master%20character%20in%20flowing%20robes%20on%20mountain%20peak%2C%20dramatic%20clouds%20and%20warm%20golden%20sunrise%20lighting%2C%20clean%20simple%20background%20in%20cream%20tone%2C%20epic%20wuxia%20atmosphere%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-26&orientation=portrait",
    category: "热血",
    rating: 9.8,
    chapters: 298,
    status: "连载中",
    updateTime: "2026-07-03",
    description: "武林大会在即，各路豪杰齐聚，一场巅峰对决即将上演。",
    longDescription: "武林大会在即，各路豪杰齐聚，一场巅峰对决即将上演。天下武功，唯快不破；江湖恩怨，一决高下。在这场举世瞩目的武林盛事中，谁能笑到最后，成为新一代武林至尊？"
  },
  {
    id: 27,
    title: "鬼怪诊所",
    author: "文彩元",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20medical%20comic%20cover%20art%2C%20doctor%20character%20in%20white%20coat%20treating%20ghostly%20patient%20in%20mysterious%20clinic%2C%20warm%20eerie%20lighting%20with%20amber%20tones%2C%20clean%20simple%20background%20in%20dark%20cream%20tone%2C%20mysterious%20yet%20cozy%20atmosphere%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-27&orientation=portrait",
    category: "悬疑",
    rating: 9.3,
    chapters: 55,
    status: "连载中",
    updateTime: "2026-06-25",
    description: "专门为鬼怪看病的诊所，每一个病人都有一个未了的心愿。",
    longDescription: "专门为鬼怪看病的诊所，每一个病人都有一个未了的心愿。当医生能够看见鬼魂，他的诊所便成了连接阴阳两界的特殊场所。通过治愈鬼怪的病痛，他也逐渐理解了生命的真谛。"
  },
  {
    id: 28,
    title: "我的奇幻邻居",
    author: "金泰梨",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20urban%20fantasy%20comedy%20comic%20cover%20art%2C%20quirky%20magical%20neighbor%20character%20greeting%20with%20magical%20sparkles%20in%20apartment%20hallway%2C%20warm%20cheerful%20atmosphere%2C%20clean%20simple%20background%20in%20light%20cream%20tone%2C%20whimsical%20urban%20fantasy%20aesthetic%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-28&orientation=portrait",
    category: "奇幻",
    rating: 9.2,
    chapters: 112,
    status: "连载中",
    updateTime: "2026-07-02",
    description: "搬来了一位会魔法的邻居，平静的生活从此变得妙趣横生。",
    longDescription: "搬来了一位会魔法的邻居，平静的生活从此变得妙趣横生。从会飞的扫帚到会说话的猫，每一天都是全新的奇妙冒险。这部漫画以轻松幽默的笔触，描绘了都市生活中那些不可思议的温暖瞬间。"
  },
  {
    id: 29,
    title: "考试冲刺班",
    author: "李政宰",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20study%20drama%20comic%20cover%20art%2C%20students%20studying%20intensely%20in%20late-night%20classroom%2C%20warm%20desk%20lamp%20lighting%2C%20clean%20simple%20background%20in%20beige%20tone%2C%20youthful%20academic%20atmosphere%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-29&orientation=portrait",
    category: "校园",
    rating: 9.1,
    chapters: 88,
    status: "已完结",
    updateTime: "2026-04-10",
    description: "高考冲刺班的日日夜夜，青春在奋斗中绽放最绚烂的光芒。",
    longDescription: "高考冲刺班的日日夜夜，青春在奋斗中绽放最绚烂的光芒。为了理想大学，一群少年少女在最后一年里拼尽全力。有欢笑、有泪水、有挫折、有成功——这是每一个经历过学生时代的人都能够感同身受的故事。"
  },
  {
    id: 30,
    title: "冰雪女王",
    author: "郑有美",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20ice%20queen%20fantasy%20comic%20cover%20art%2C%20elegant%20ice%20queen%20character%20with%20crystalline%20crown%20in%20frozen%20palace%2C%20beautiful%20cool%20lighting%20with%20warm%20undertones%2C%20clean%20simple%20background%20in%20icy%20cream%20tone%2C%20regal%20fantasy%20atmosphere%2C%20high%20quality%20digital%20illustration&width=400&height=560&seq=comic-cover-30&orientation=portrait",
    category: "奇幻",
    rating: 9.5,
    chapters: 168,
    status: "已完结",
    updateTime: "2026-03-20",
    description: "冰雪女王的传说，一段关于爱与牺牲的永恒传奇。",
    longDescription: "冰雪女王的传说，一段关于爱与牺牲的永恒传奇。在冰封的王国中，一位孤独的女王守护着最后的希望。当真爱融化千年寒冰，春天终于重回大地——这是一个比冰雪更纯净、比火焰更炽热的爱情故事。"
  },
];

export function getChapters(comicId: number): { number: number; title: string; updateTime: string }[] {
  const total = (allComics.find((c) => c.id === comicId)?.chapters ?? 0);
  const chapters: { number: number; title: string; updateTime: string }[] = [];
  const dates = ['2026-07-03', '2026-07-01', '2026-06-28', '2026-06-25', '2026-06-22', '2026-06-19', '2026-06-16', '2026-06-13', '2026-06-10', '2026-06-07', '2026-06-04', '2026-06-01'];
  const titles = [
    '命运的相遇', '暗流涌动', '风暴前夕', '真相浮现', '决断之时',
    '新的征程', '意外转折', '重逢之刻', '决心已定', '终极对决',
    '黎明将至', '破晓之光'
  ];
  for (let i = total; i >= 1; i--) {
    chapters.push({
      number: i,
      title: `第${i}话 - ${titles[(i - 1) % titles.length]}`,
      updateTime: dates[(i - 1) % dates.length],
    });
  }
  return chapters;
}

export function getRelatedComics(comicId: number, count: number = 6): ComicDetail[] {
  const comic = allComics.find((c) => c.id === comicId);
  if (!comic) return [];
  const sameCategory = allComics.filter((c) => c.id !== comicId && c.category === comic.category);
  const shuffled = [...sameCategory].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}

export function getComicsByCategory(slug: string): ComicDetail[] {
  const categoryMap: Record<string, string> = {
    romance: '恋爱',
    action: '热血',
    mystery: '悬疑',
    urban: '都市',
    fantasy: '奇幻',
    school: '校园',
    food: '美食',
    scifi: '科幻',
    history: '历史',
    sports: '运动',
  };
  const categoryName = categoryMap[slug];
  if (!categoryName) return [];
  return allComics.filter((c) => c.category === categoryName);
}

export function getCategoryName(slug: string): string {
  const categoryMap: Record<string, string> = {
    romance: '恋爱',
    action: '热血',
    mystery: '悬疑',
    urban: '都市',
    fantasy: '奇幻',
    school: '校园',
    food: '美食',
    scifi: '科幻',
    history: '历史',
    sports: '运动',
  };
  return categoryMap[slug] || '';
}